<template>
  <div class="video-formats" :class="{small: props.size === 'small'}">
    <div class="video-format-item" v-for="format in props.formats" :key="format.id" :class="{selected: isSelected(format)}" @click="toggle(format)">
      <div class="video-format-screen" :class="{[getFormatClass(format)]: true}"></div>
      <div class="video-format-item-text">{{ format.title }}</div>
    </div>
  </div>
</template>

<script setup>

const emit = defineEmits(['toggle']);
const props = defineProps({
  formats: {type: Array, required: true},
  selectedFormats: {type: Array, default: () => []},
  size: {type: String, default: ''}
});

const isSelected = format => props.selectedFormats.includes(format.id);
const getFormatClass = (format) => 'screen-' + format.title.replace(':', '-');
const toggle = format => emit('toggle', format);
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/theme_variables";

.video-formats {
  display: flex;

  &.small {
    .video-format-item {
      width: auto;
      height: auto;
      padding: toRem(6) toRem(15);
      flex-direction: row;
      font-size: toRem(14);

      & + .video-format-item {
        margin-left: toRem(8);
      }
    }

    .video-format-screen {
      border-width: 1px;
      margin-right: toRem(8);

      &.screen-1-1 {
        width: 13px;
        height: 13px;
      }

      &.screen-4-5 {
        width: 12px;
        height: 15px;
      }

      &.screen-9-16 {
        width: 10px;
        height: 15px;
      }
    }
  }
}

.video-format-item {
  position: relative;
  width: toRem(172);
  height: toRem(140);
  padding: toRem(16);
  background: $gray;
  border: 2px solid transparent;
  color: $shade600;
  border-radius: $borderRadius;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  cursor: pointer;

  &.selected {
    border-color: #0F8BFD;
    border-radius: $borderRadius;
  }

  & + & {
    margin-left: toRem(16);
  }

  &.selected {
    &:before {
      display: flex;
      position: absolute;
      top: toRem(8);
      right: toRem(8);
      width: toRem(16);
      height: toRem(16);
      background: $primaryColor;
      font-family: 'primeicons';
      justify-content: center;
      align-items: center;
      content: '\e909';
      color: #fff;
      border-radius: 50%;
      font-size: toRem(8);
      font-weight: bold;
    }

    .video-format-screen {
      border-color: $primaryColor;
    }
  }
}

.video-format-screen {
  border: 2px solid $shade500;
  border-radius: 4px;

  &.screen-1-1 {
    width: 60px;
    height: 60px;
  }

  &.screen-4-5 {
    width: 58px;
    height: 72px;
  }

  &.screen-9-16 {
    width: 36px;
    height: 76px;
  }
}
</style>
